import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab1 from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Main from './main';
import VCard from './VCard';
import File from './File';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import PaymentCheckoutSocial from '../../../components/Payment/PaymentCheckoutSocial';
import axios from 'axios';
import TopupCheckoutSocial from '../../../components/Payment/TopupCheckoutSocial';
import { useUser } from '../../../Context/UserContext';
import AllQRHero from './AllQRHero';
import PaymentCheckoutSocialSwitch from '../../../components/Payment/PaymentCheckoutSocialSwitch';
import { CircularProgress } from "@mui/material";
import { getToken } from '../../../utils/auth';
import Card from '../../../components/Card';
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);
  const { t, i18n } = useTranslation();
  const { userData } = useUser();
  // console.log("userdata", userData)
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [user, setUser] = React.useState("");
  const [available, setAvailable] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const defaultCurrency = "USD";
  const defaultSymbol = "$";
  const [selectedCurrency, setSelectedCurrency] = React.useState(
    localStorage.getItem("selectedCurrency") || defaultCurrency
  );
  const [currencySymbol, setCurrencySymbol] = React.useState(
    localStorage.getItem("currencySymbol") || defaultSymbol
  );

  const fetchUserData = async () => {
    try {
      setLoading(true);

      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUser(response?.data?.data);
    } catch (error) {
      console.error("Failed Fetching Details", error);
    } finally {
      setLoading(false);
    }
  };

  const topupAvailable = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/plan/user/purchesed-plan?platform=social-net`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setAvailable(response?.data?.data);
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };
  React.useEffect(() => {
    fetchUserData();
    topupAvailable();
  }, []);
  if (userData === undefined) {
    return (
      <div style={styles.loaderOverlay}>
        <CircularProgress style={{ color: "white" }} />
      </div>
    ); // or show a loader
  }
  const styles = {
    loaderOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    },
  };
  return (
    <>
      {loading && (
        <div style={styles.loaderOverlay}>
          <CircularProgress style={{ color: "white" }} />
        </div>
      )}
      <Box sx={{ width: "100%", justifyContent:"right" }}>
           {user?.isEnrolledInSocialNet ? (
            <div style={{ display: "flex", gap: "10px" }}>
              {/* <TopupCheckoutSocial selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/> */}
              <PaymentCheckoutSocialSwitch
                selectedCurrency={selectedCurrency}
                currencySymbol={currencySymbol}
              />
            </div>
          ) : (
            <PaymentCheckoutSocial
              selectedCurrency={selectedCurrency}
              currencySymbol={currencySymbol}
            />
          )}
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="basic tabs example"
          >
            <Tab1 label={t("url")} {...a11yProps(0)} />
            <Tab1 label={t("vCard")} {...a11yProps(1)} />
            <Tab1 label={t("file")} {...a11yProps(2)} />
            <Tab1 label={t("all_qr_hero")} {...a11yProps(3)} />
          </Tabs>
          {/* {user?.isEnrolledInSocialNet ? (
            <div style={{ display: "flex", gap: "10px" }}>
              <PaymentCheckoutSocialSwitch
                selectedCurrency={selectedCurrency}
                currencySymbol={currencySymbol}
              />
            </div>
          ) : (
            <PaymentCheckoutSocial
              selectedCurrency={selectedCurrency}
              currencySymbol={currencySymbol}
            />
          )} */}
        </Box>
        <CustomTabPanel value={value} index={0} style={{ padding: 0 }}>
          {/* URL */}
          <Main
            available={available}
            userData={user}
            topupAvailable={topupAvailable}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          {/* vCard */}
          <VCard userData={user} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          {/* File */}
          <File userData={user} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          {/* vCard */}
          <AllQRHero />
        </CustomTabPanel>
      </Box>
    </>
  );
}
